module.exports = __webpack_public_path__ + "static/media/epam_logo.33ced2d4.png";